/* eslint-disable no-magic-numbers */
import React from 'react';

import { IIconProps } from './constants';

export const SearchIcon = ({
  size = undefined,
  width = 24,
  height = 24,
  title = '',
  ariaLabel = 'Search icon',
  ariaHidden = false,
  className = '',
  ...props
}: IIconProps) => {
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      data-testid="SearchIcon"
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke="#061D33"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9999 21L16.6499 16.65"
        stroke="#061D33"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
